import constants from '../constants.js';


const CarSuppliersLocationsDeliveryCollectionSupport = {
  displayName: 'Delivery Collection Support',
  dataAt: "DeliveryCollectionSupport",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DeliveryCollectionSupport"
};

const CarSuppliersLocationsLongitude = {
  displayName: 'Longitude',
  dataAt: 'Longitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: -9999999999,
  max: 9999999999
};


const CarSuppliersLocationsLatitude = {
  displayName: "Latitude",
  dataAt: "Latitude",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  min: -9999999999,
  max: 9999999999
};

const CarSuppliersLocationsCountryCode = {
  displayName: "Country Code",
  dataAt: "CountryCode",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: "single"
};


const CarSuppliersLocationsStateCode = {
  displayName: "State Code",
  dataAt: "StateCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsLocationName = {
  displayName: "Location Name",
  dataAt: "LocationName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsAddressLine = {
  displayName: "Address Line",
  dataAt: "AddressLine",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsNoRateReturned = {
  displayName: "No Rate Returned",
  dataAt: "NoRateReturned",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CarSuppliersLocationsCityName = {
  displayName: "City Name",
  dataAt: "CityName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsLocationCode = {
  displayName: "Location Code",
  dataAt: "LocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsExtendedLocationCode = {
  displayName: "Extended Location Code",
  dataAt: "ExtendedLocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CarSuppliersLocationsTitle = {
  displayName: "Title",
  dataAt: "Title",
  displayAs: "text-input"
};

const CarSuppliersLocationsGridItem = {
  displayName: "Car Supplier Location",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    CarSuppliersLocationsTitle,
    CarSuppliersLocationsExtendedLocationCode,
    CarSuppliersLocationsLocationCode,
    CarSuppliersLocationsLocationName,
    CarSuppliersLocationsNoRateReturned,
    CarSuppliersLocationsAddressLine,
    CarSuppliersLocationsCityName,
    CarSuppliersLocationsStateCode,
    CarSuppliersLocationsCountryCode,
    CarSuppliersLocationsLatitude,
    CarSuppliersLocationsLongitude,
    CarSuppliersLocationsDeliveryCollectionSupport
  ],
  endpoint: "CarSupplierLocations",
  routeParamId: "CarSupLocItem"
};


const CarSuppliersLocations = {
  rootNode: true,
  displayName: 'Car Supplier Locations',
  displayAs: constants.DISPLAY_AS.SEARCH_BY,
  endpoint: 'CarSupplierLocations',
  targetChoices:
    ['Title',
      'SupplierCode',
      'LocationCode',
      'AddressLine',
      'CityName',
      'CountryCode']
};

export default {
  CarSuppliersLocations,
  CarSuppliersLocationsGridItem,
  CarSuppliersLocationsTitle,
  CarSuppliersLocationsExtendedLocationCode,
  CarSuppliersLocationsLocationCode,
  CarSuppliersLocationsLocationName,
  CarSuppliersLocationsNoRateReturned,
  CarSuppliersLocationsAddressLine,
  CarSuppliersLocationsCityName,
  CarSuppliersLocationsStateCode,
  CarSuppliersLocationsCountryCode,
  CarSuppliersLocationsLatitude,
  CarSuppliersLocationsLongitude,
  CarSuppliersLocationsDeliveryCollectionSupport
}



// WEBPACK FOOTER //
// ./src/config/fields/carSuppliersLocations.js